import { render, staticRenderFns } from "./ModalFileDetail.vue?vue&type=template&id=68d92b28&scoped=true"
import script from "./ModalFileDetail.vue?vue&type=script&lang=js"
export * from "./ModalFileDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d92b28",
  null
  
)

export default component.exports